/* Built In Imports */
import { Box, Image, Link, Text } from '@chakra-ui/react';

/* Internal Imports */
/* Components */
import config from '@config';

/**
 * @description Renders the Yantra Footer component.
 * @param {Array} footerData
 * @returns {ReactElement} Yantra Footer contactus component.
 */
const YantraContactUs = ({ secData, pageData }) => {
  const footer = pageData?.body.find(el => el.sectionId == secData);
  const footerData = footer?.sectionContent;
  return (
    <Box
      textAlign="center"
      color="#fff"
      width={{ base: '100%', md: '50%' }}
      mx="auto"
      my="50px"
    >
      <Text
        as="h1"
        color="#fff"
        mb="12px"
        fontSize={{
          base: '27px',
          md: '32px',
        }}
      >
        {footerData[0]?.text}
      </Text>
      <Image
        src={`${config.imgPath}/d/46272/1656741032-divider_yellow.png`}
        alt="divider"
        title="Divider"
        mb="60px"
      />
      {footerData[1].text !== '' && (
        <Text
          fontFamily="FedraSansStd-medium"
          fontSize={{ base: '18px', md: '24px' }}
          mb="20px"
        >
          {footerData[1]?.text}
        </Text>
      )}
      <Box as="p" className="footerlink">
        <Link
          fontFamily="FedraSansStd-medium"
          fontSize={{ base: '18px', md: '24px' }}
          mb="30px"
          href={'mailto:' + footerData[2]?.text}
          lineHeight="25px"
        >
          {footerData[2]?.text}
        </Link>
      </Box>
      <style jsx global>
        {`
          .footerlink a {
            color: #ffffff !important;
            text-decoration: underline;
          }
        `}
      </style>
    </Box>
  );
};

export default YantraContactUs;
